import React, { useContext } from 'react';
import { compact } from 'lodash';

import Chapter from '../../Chapter';
import ChapterPlayerContext from '../../ChapterPlayer.context';
import { AssetType } from '../../../../utils/storage';

import CampaignIntro, {
    CampaignIntroProps,
    calculateDuration,
    calculateExitDuration,
} from './screens/CampaignIntro';
import { MediaType } from './shared';

import './styles/fonts.scss';


type CampaignIntroData = CampaignIntroProps & {
    media?: MediaType,
    overlay?: {
        variant?: string,
        data?: MediaType | Record<string, string>,
        media?: MediaType,
    },
};

type CampaignIntroViewProps = {
    data: CampaignIntroData,
    languages: string[],
};

function CampaignIntroView({ data, languages }: CampaignIntroViewProps) {
    const {
        width,
        height,
    } = useContext(ChapterPlayerContext);

    const resolvedLanguages = data.languages?.length
        ? data.languages
        : (languages?.length ? languages : ['EN']);

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                ['--rise-font-vertical-correction' as string]: '1',
            }}
        >
            <CampaignIntro
                {...data}
                width={width}
                height={height}
                languages={resolvedLanguages}
            />
        </div>
    );
}

export default class CampaignIntroChapter extends Chapter<CampaignIntroData> {
    component = () => (
        <CampaignIntroView
            data={this.data}
            languages={this.languages}
        />
    )

    fonts = [
        'NTSuperExtended',
        'HelveticaNowDisplay',
    ]

    calculateDuration() {
        const data = this.getChapterData();

        return (calculateDuration(data) - calculateExitDuration(data)) / 1000;
    }

    getAssetsToCache(): AssetType[] {
        const {
            media,
            overlay,
        } = this.data;

        const overlayMedia = overlay?.variant === 'media'
            ? (overlay.data as MediaType)
            : overlay?.media;

        return compact([media, overlayMedia]).filter(asset => asset?.url);
    }

    private getChapterData(): CampaignIntroProps {
        const languages = this.data.languages?.length
            ? this.data.languages
            : (this.languages?.length ? this.languages : ['EN']);

        return {
            ...this.data,
            languages,
        };
    }
}
